import IApiProvider from '../../infrastructure/providers/abstract/IApiProvider';
import MerpsApiProvider from '../../infrastructure/providers/pb-adapter/MerpsApiProvider';
import { IRuntimeConfigService } from '../rt-config/IRuntimeConfigService';
import RuntimeConfigService from '../rt-config/RuntimeConfigService';

import { IConnectionService } from './IConnectionService';

/**
 * Default implementation of {@link IConnectionService}
 * that uses {@link IApiProvider}'s `connect` method.
 */
class ConnectionServiceSingleton implements IConnectionService {
  private readonly apiProvider: IApiProvider;
  private readonly rtConfigService: IRuntimeConfigService;
  private connected = false;

  constructor() {
    this.apiProvider = new MerpsApiProvider();
    this.rtConfigService = new RuntimeConfigService();
  }

  public async connect(): Promise<boolean> {
    const config = await this.rtConfigService.getRuntimeApiConfig();

    await this.apiProvider
      .connect(config.url, config.connectOptions)
      .then(() => {
        this.connected = true;
      })
      .catch(() => {
        this.connected = false;
      });
    return this.connected;
  }

  public isConnected(): boolean {
    return this.connected;
  }

  public setConnected(connected: boolean): void {
    this.connected = connected;
  }

  public get connectionId(): string | null {
    return this.apiProvider.rpc.connectionId;
  }
}

const ConnectionService = (() => {
  let instance: IConnectionService;
  return new Proxy(ConnectionServiceSingleton, {
    construct(Target: typeof ConnectionServiceSingleton): IConnectionService {
      if (!instance) {
        instance = new Target();
      }
      return instance;
    },
  });
})();

export default ConnectionService;
